import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCopyInfo } from '@/api/mkt';
import useAccount from '@/store/account';
import { getCookie } from '@/utils/cookie';
import Constant from '@/constants/const';
import { isEmptyObject } from '@/utils/isEmpty';
import { getLoginState } from '@/utils/common/user';

export enum DiscountCopyKey {
  content_onboarding = 'h5_content_onboarding',
  bindEmailTitle_home = 'h5_bindEmailTitle_home',
  topMessageBindPhoneTitle = 'h5_topMessageBindPhoneTitle',
  bindPhoneTitle = 'h5_bindPhoneTitle_phone_connect',
  bindPhoneTitle_ios = 'ios_bindPhoneTitle_phone_connect',
  bindPhoneTitle_android = 'android_bindPhoneTitle_phone_connect',
  bindPhoneSubtitle = 'h5_bindPhoneSubtitle_phone_connect',
  onboardingDiscount_onboarding = 'h5_onboardingDiscount_onboarding',
  unLoginNotice_category = 'h5_unLoginNotice_category',
  landingTopMessage_product = 'h5_landingTopMessage_product',
  topMessageShip_product = 'h5_topMessageShip_product',
  topMessageDelivery_product = 'h5_topMessageDelivery_product'
}

interface Props {
  source?: string;
}

const useGetDiscountCopy = (props?: Props) => {
  const { setDiscountCopy, userPreOrderLogged } = useAccount();
  const isLogin = getLoginState();
  const { query, isReady, asPath, locale } = useRouter();

  useEffect(() => {
    if (!isReady) return;
    if (!userPreOrderLogged) return;
    const disCountState = sessionStorage?.getItem(Constant.H5_UPDATE_DISCOUNT_INFO);
    const discountInfo = sessionStorage?.getItem(Constant.H5_DISCOUNT_INFO);
    const _info = !!discountInfo ? JSON.parse(discountInfo) : null;
    if (!isEmptyObject(_info) && disCountState === `${locale}` && !asPath.includes('/account/phone-connect')) {
      setDiscountCopy(_info);
      return;
    }
    const getData = async () => {
      let postData: {
        referrer_id?: string;
        ep_partner?: string;
        channel_type?: string;
        source?: string;
        referral_type?: string;
      } = {
        channel_type: (query.channel_type as string) || '',
        referral_type: (query.referral_type as string) || '',
        source: (props?.source as string) || ''
      };
      const referrer_id = getCookie(Constant.REFERRER_ID);
      if (referrer_id) {
        postData.referrer_id = referrer_id;
      }
      const ep_partner = getCookie(Constant.EP_PARTNER);
      if (ep_partner) {
        postData.ep_partner = ep_partner;
      }
      const res = await getCopyInfo(postData);
      if (res?.result && res?.object) {
        setDiscountCopy({
          ...res.object
        });
        window.sessionStorage.setItem(Constant.H5_UPDATE_DISCOUNT_INFO, `${locale}`);
        window.sessionStorage.setItem(Constant.H5_DISCOUNT_INFO, JSON.stringify(res.object));
      }
    };
    getData();
  }, [isReady, isLogin, userPreOrderLogged]);
};

export default useGetDiscountCopy;
